/**
 * Renders Youtube Videos from a products media_links attribute.
 * 
 * YT embedded iframe code could change! 
 */

import React from 'react';
import classNames from 'classnames';

import { MediaLink } from '@ttstr/api/products';

interface OwnProps {
  productMediaLinks: MediaLink[];
  allowFullScreenYTVideos?: boolean;
  hideYTControls?: boolean;
  containerClassName?: string;
}

type Props = Readonly<OwnProps>;

const MediaLinksComponent: React.FC<Props> = ({
  productMediaLinks,
  allowFullScreenYTVideos = true,
  hideYTControls = false,
  containerClassName,
}) => {

  if (!productMediaLinks.length) return null;

  return (
    <div className={classNames('medialinks-container', 'embed-responsive', containerClassName)} >
      {productMediaLinks.map((mediaLink, index) => 
        mediaLink.typ === 'youtube' ?
        <iframe
          key={index}
          title={mediaLink.title}
          width="100%"
          height="100%"
          src={`https://www.youtube.com/embed/${mediaLink.link}${hideYTControls ? '?controls=0' : ''}`}
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen={allowFullScreenYTVideos}
        /> :
        <></>
      )}
    </div>
  );
};

export default MediaLinksComponent;
